import { useCallback, useState } from "react";

import type { ChartExploreContext } from "src/analytics/copilot/chartExploreContext";

export type ChartExplore = {
  pendingChartContext: ChartExploreContext | null;
  exploreWithCopilot: (context: ChartExploreContext) => void;
  clearPendingContext: () => void;
};

export const useChartExplore = (openCopilot: () => void): ChartExplore => {
  const [pendingChartContext, setPendingChartContext] =
    useState<ChartExploreContext | null>(null);

  const exploreWithCopilot = useCallback(
    (context: ChartExploreContext) => {
      setPendingChartContext(context);
      openCopilot();
    },
    [openCopilot],
  );

  const clearPendingContext = useCallback(
    () => setPendingChartContext(null),
    [],
  );

  return {
    pendingChartContext,
    exploreWithCopilot,
    clearPendingContext,
  };
};
